/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CredentialAuthenticateResponse } from '../models/CredentialAuthenticateResponse';
import type { GoogleLogin } from '../models/GoogleLogin';
import type { RefreshTokenRequest } from '../models/RefreshTokenRequest';
import type { ResetPassword } from '../models/ResetPassword';
import type { Token } from '../models/Token';
import type { UserLogin } from '../models/UserLogin';
import type { ValidateOTP } from '../models/ValidateOTP';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * @returns Token
     * @throws ApiError
     */
    public static authGoogleLoginCreate({
        requestBody,
    }: {
        requestBody: GoogleLogin,
    }): CancelablePromise<Token> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/google_login/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns CredentialAuthenticateResponse
     * @throws ApiError
     */
    public static authLoginCreate({
        requestBody,
    }: {
        requestBody: UserLogin,
    }): CancelablePromise<CredentialAuthenticateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/login/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    public static authLoginLDAPCreate({
        requestBody,
    }: {
        requestBody: UserLogin,
    }): CancelablePromise<CredentialAuthenticateResponse> {
        requestBody["mode"] = "ldap"
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/login/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Token
     * @throws ApiError
     */
    public static authRefreshCreate({
        requestBody,
    }: {
        requestBody: RefreshTokenRequest,
    }): CancelablePromise<Token> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/refresh/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Resend two factor email otp for a particular user
     * - Requires otp_verification_token generated while calling login
     * @returns CredentialAuthenticateResponse
     * @throws ApiError
     */
    public static authResendEmailOtpCreate({
        requestBody,
    }: {
        requestBody: ValidateOTP,
    }): CancelablePromise<CredentialAuthenticateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/resend_email_otp/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static authResetPasswordCreate({
        requestBody,
    }: {
        requestBody: ResetPassword,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/reset_password/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static authUpdatePasswordRetrieve(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/update_password/',
        });
    }
    /**
     * @returns Token
     * @throws ApiError
     */
    public static authValidateOtpCreate({
        requestBody,
    }: {
        requestBody: ValidateOTP,
    }): CancelablePromise<Token> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/validate_otp/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
